<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import { mapGetters } from 'vuex'
export default {
    name: 'NotFound',
    components: { ImageWrapper },
    computed: {
        ...mapGetters(['smDevice']),
    },
}
</script>

<template lang="pug">
.container-fluid.container-lg.page-not-found.pt-0
    .row
        .col-12.col-md-6.d-flex.align-item-center.justify-content-center.flex-column(:class="{'text-center': smDevice}")
            h1.display-6.mb-6 {{$t('notfound.title')}}
            .h6.text-73.mb-0 {{$t('notfound.text_1')}}
            .h6.text-73.mb-9 {{$t('notfound.text_2')}}
            router-link.btn.btn-primary(:to="{name: 'restaurant-list'}" :class="smDevice ? 'btn-sm' : 'btn-lg'")
                | {{$t('notfound.button')}}
        .col-12.col-md-6(v-if="!smDevice")
            image-wrapper(src="/images/guy.png" fill)
</template>
